import React, { useContext } from "react";

import {
  Box,
  Typography,
  Button,
  TextField,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";

import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import WarningIcon from "@material-ui/icons/Warning";

import { AutoRegistrationContext } from "../../../context/AutoRegistrationProvider";
import useStyles from "./styles";
import { useFormik } from "formik";
import { validationSchema } from "./validationSchema";

export const NotesFirstStep = ({ changeStep }) => {
  const { setStep, data, setData } = useContext(AutoRegistrationContext);

  const classes = useStyles();

  const handleSubmitForm = (values) => {
    setData(values);
    changeStep(1);
  };

  const handleGoBack = () => {
    setData({});
    setStep(0);
  };

  const formik = useFormik({
    initialValues: {
      usertype: data?.usertype || "driver",
      firstname: data?.firstname || "",
      surname: data?.surname || "",
      email: data?.email || "",
    },
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: handleSubmitForm,
  });

  const isDisabledBtn = () => {
    const errors = Object.values(formik.errors);
    if (errors.length > 0) return true;

    return !(
      !!formik.values.firstname &&
      !!formik.values.surname &&
      !!formik.values.email
    );
  };

  return (
    <Box className={classes.registrationContainer}>
      <Box className={classes.info}>
        <WarningIcon />
        <Typography className={classes.infoText}>
          Todos os dados devem ser preenchidos exatamente como aparecem na ordem
          de carregamento.
        </Typography>
      </Box>
      <form
        encType="multipart/form-data"
        className={classes.form}
        onSubmit={formik.handleSubmit}
      >
        <Box className={classes.typeClientContainer}>
          <Typography variant="h5" align="left">
            Eu sou?*
          </Typography>
          <RadioGroup
            row
            aria-label="usertype"
            name="usertype"
            data-cy="usertype-rdo"
            value={formik.values.usertype}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            className={classes.radioButtonIAm}
          >
            <FormControlLabel
              value="driver"
              control={<Radio />}
              label="Motorista"
              flex={1}
            />
            <FormControlLabel
              value="transporter"
              control={<Radio />}
              label="Responsável por transportadora"
              flex={1}
            />
          </RadioGroup>
        </Box>
        <Box className={classes.inputContainer}>
          <Typography variant="h5" align="left">
            Primeiro nome*
          </Typography>
          <TextField
            value={formik.values.firstname}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            error={!!formik.errors.firstname}
            helperText={formik.errors.firstname && formik.errors.firstname}
            variant="outlined"
            id="firstname-inp"
            data-cy="firstname-inp"
            name="firstname"
            placeholder="Informe seu nome"
          />
        </Box>
        <Box className={classes.inputContainer}>
          <Typography variant="h5" align="left">
            Sobrenome*
          </Typography>
          <TextField
            value={formik.values.surname}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            error={!!formik.errors.surname}
            helperText={formik.errors.surname && formik.errors.surname}
            variant="outlined"
            id="surname-inp"
            data-cy="surname-inp"
            name="surname"
            placeholder="Informe seu sobrenome"
          />
        </Box>
        <Box className={classes.inputContainer}>
          <Typography variant="h5" align="left">
            E-mail*
          </Typography>
          <TextField
            value={formik.values.email}
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            error={!!formik.errors.email}
            helperText={formik.errors.email && formik.errors.email}
            variant="outlined"
            id="email-inp"
            type="email"
            data-cy="email-inp"
            name="email"
            placeholder="Informe seu e-mail"
          />
        </Box>
        <Box className={classes.actionButtons}>
          <Button
            id="goBack-btn"
            data-cy="goBack-btn"
            variant="outlined"
            className="goBack"
            color="primary"
            type="button"
            onClick={handleGoBack}
            size="large"
          >
            <ArrowBackIosIcon /> Voltar
          </Button>
          <Box display="flex" alignItems="center">
            <Typography className={classes.mandatoryField}>
              *Preenchimento obrigatório.
            </Typography>
            <Button
              id="next-btn"
              data-cy="next-btn"
              variant="contained"
              className="next"
              color="primary"
              size="large"
              type="submit"
              disabled={isDisabledBtn()}
            >
              Continuar
            </Button>
          </Box>
        </Box>
      </form>
    </Box>
  );
};
